// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-txn-where {
  display: block;
  margin: var(--wm-feature-details-margin);
}
wm-txn-where .wm-txn-where-title {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: var(--wm-feature-details-title-font-size);
  font-weight: var(--wm-feature-details-title-font-weight);
  color: var(--wm-feature-details-title-color);
  font-family: var(--wm-feature-details-title-font-family);
}
wm-txn-where .wm-txn-where-item {
  font-size: var(--wm-font-mf);
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: space-between;
}
wm-txn-where .wm-txn-where-item .wm-txn-where-label {
  font-weight: 400;
  font-family: var(--wm-font-family-content);
  flex-shrink: 0;
  min-width: 30%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  white-space: normal;
  display: flex;
  align-items: center;
  gap: 4px;
}
wm-txn-where .wm-txn-where-item .wm-txn-where-icon {
  color: var(--wm-color-primary);
  flex-shrink: 0;
}
wm-txn-where .wm-txn-where-item .wm-txn-where-value {
  font-weight: 600;
  font-family: var(--wm-font-family-content);
  flex: 1;
  text-align: right;
  overflow-wrap: break-word;
  word-wrap: break-word;
  white-space: normal;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/taxonomy-where/taxonomy-where.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,wCAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oDAAA;EACA,wDAAA;EACA,4CAAA;EACA,wDAAA;AACJ;AAEE;EACE,4BAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,8BAAA;AAAJ;AAEI;EACE,gBAAA;EACA,0CAAA;EACA,cAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAAN;AAGI;EACE,8BAAA;EACA,cAAA;AADN;AAII;EACE,gBAAA;EACA,0CAAA;EACA,OAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;AAFN","sourcesContent":["wm-txn-where {\n  display: block;\n  margin: var(--wm-feature-details-margin);\n\n  .wm-txn-where-title {\n    display: flex;\n    align-items: center;\n    gap: 3px;\n    font-size: var(--wm-feature-details-title-font-size);\n    font-weight: var(--wm-feature-details-title-font-weight);\n    color: var(--wm-feature-details-title-color);\n    font-family: var(--wm-feature-details-title-font-family);\n  }\n\n  .wm-txn-where-item {\n    font-size: var(--wm-font-mf);\n    display: flex;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    justify-content: space-between;\n\n    .wm-txn-where-label {\n      font-weight: 400;\n      font-family: var(--wm-font-family-content);\n      flex-shrink: 0;\n      min-width: 30%;\n      overflow-wrap: break-word;\n      word-wrap: break-word;\n      white-space: normal;\n      display: flex;\n      align-items: center;\n      gap: 4px;\n    }\n\n    .wm-txn-where-icon {\n      color: var(--wm-color-primary);\n      flex-shrink: 0;\n    }\n\n    .wm-txn-where-value {\n      font-weight: 600;\n      font-family: var(--wm-font-family-content);\n      flex: 1;\n      text-align: right;\n      overflow-wrap: break-word;\n      word-wrap: break-word;\n      white-space: normal;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
